export enum ProductDisplayView {
  Card = 'Card',
  Grid = 'Grid',
}
